define('MachineFit.Model',
  [
    'Backbone.Model',
    'Utils'
  ],
  function (
    BackboneModel,
    Utils
  ) {
    'use strict';

    return BackboneModel.extend({
      urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/MachineFit.Service.ss'))
    });
  });
